export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
>
  <g
    transform="matrix(0.03156311,0,0,0.03156311,-1.38884,-8.603185)"
  >
    <path
      d="m 614.286,676.571 q 0,7.429 -5.714,13.143 l -28.571,28.571 q -5.714,5.714 -13.143,5.714 -7.429,0 -13.143,-5.714 L 329.144,493.714 104.573,718.285 q -5.714,5.714 -13.143,5.714 -7.429,0 -13.143,-5.714 L 49.716,689.714 Q 44.002,684 44.002,676.571 q 0,-7.429 5.714,-13.143 L 316.002,397.142 q 5.714,-5.714 13.143,-5.714 7.429,0 13.143,5.714 l 266.286,266.286 q 5.714,5.714 5.714,13.143 z"
    />
  </g>
</svg>`;
